// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.validatable-input__container .is-invalid {
    border-bottom: 1px solid red !important;
}

.validatable-input__container .is-invalid:focus{
    box-shadow: 0 1px 0 0 red !important;
}

.validatable-input__container input.form-control {
    padding-bottom: 5px;
    height: auto; 
    margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/validatable-input/ValidatableInput.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".validatable-input__container .is-invalid {\r\n    border-bottom: 1px solid red !important;\r\n}\r\n\r\n.validatable-input__container .is-invalid:focus{\r\n    box-shadow: 0 1px 0 0 red !important;\r\n}\r\n\r\n.validatable-input__container input.form-control {\r\n    padding-bottom: 5px;\r\n    height: auto; \r\n    margin-top: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
